import React from 'react'
import { Typography } from '@material-ui/core'
import useStyles from './styles'
import { Link } from 'react-router-dom'
import logo from '../../assets/logo.jpg'
import clsx from 'clsx';


const Logo = ({hide}) => {
    const classes = useStyles();
    
    return (
        <Typography component={Link} to="/" variant='h6' className={clsx({[classes.title]: true, [classes.hide]: hide})}>
            <img src={logo} alt="logo" className={classes.image} />
            <span className={classes.span}>
                WESHOOOP
            </span>
        </Typography>
    )
}

export default Logo
